import { Typography } from '../../../../core/components/molecules/Typography';
import { useMaterial } from '../../hooks/useMaterials';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMaterialStore } from '../../stores/materialStore';
import { Colors, IMaterial } from '../../../../core/models/disciplines';
import { useNewSubjectStore } from '../../stores/newSubjectStore';
import { useFilterConfigStore } from '../../stores/filterConfig';
import { IResponseFavorite } from '../../hooks/useContentFavorite';
import { useFinishMaterial } from '../../../../core/hooks/useFinishMaterial';
import SectionHeader from '../sectionHeader';
import CardLoader from '../cardLoading';
import ContentCard from '../../../../core/components/organism/ContentCard';
import getSubjectByFilter from '../../../../core/commom/getSubjectByFilter';
import FilterModal from '../ModalFilter';

interface IMaterialList {
  module: string;
  discipline: Colors;
  url: string;
}

export default function MaterialList({ module, discipline, url }: IMaterialList) {
  const navigate = useNavigate();

  const { mutate, isPending } = useMaterial();
  const { resetFilters, status, favorites } = useFilterConfigStore();
  const { selectedSubjects } = useNewSubjectStore();
  const { materials, setAllMaterials } = useMaterialStore();

  const { mutate: finishMaterial, isPending: isLoading, isSuccess } = useFinishMaterial();

  const [workbook, setWorkbook] = useState<IMaterial[]>([]);
  const [exercise, setExercise] = useState<IMaterial[]>([]);
  const [mindMap, setMindMap] = useState<IMaterial[]>([]);
  const [dossie, setDossie] = useState<IMaterial[]>([]);

  useEffect(() => {
    if(materials?.length > 0) {
      filterMaterials()
    }
  }, [materials, selectedSubjects])

  useEffect(() => {
    if(module) {
      mutate(module)
    }
  }, [])

  useEffect(() => {
    if(isSuccess && module) {
      mutate(module);
    }
  }, [isLoading])

  const callbackFav = (data: IResponseFavorite) => {
    if(data.ok && module) {
      mutate(module)
    }
  }

  const filterMaterials = () => {
    const aux = [...materials];
    let filteredData = aux;

    if(selectedSubjects?.length > 0) {
      filteredData = filteredData.filter((it) => selectedSubjects.includes(it.subjects[0].slug))
    }

    if(status?.length > 0) {
      if(status.includes('not_seen')) {
        filteredData = filteredData.filter((it) => !it.done)
      } else if(status.includes('seen')) {
        filteredData = filteredData.filter((it) => it.done)
      }
    }

    if(favorites) {
      filteredData = filteredData.filter((it) => it.favorite)
    }

    const workbookA:IMaterial[] = [], exerciseA:IMaterial[] = [], mindMapA:IMaterial[] = [], dossieA:IMaterial[] = [];

    filteredData.map((it) => {
      if (it.file_category === 'apostila') {
        workbookA.push(it);
      } else if (it.file_category === 'exercicios') {
        exerciseA.push(it);
      } else if (it.file_category === 'mapa_mental') {
        mindMapA.push(it);
      } else {
        dossieA.push(it);
      }
    })

    setAllMaterials(filteredData);
    setWorkbook(workbookA);
    setExercise(exerciseA);
    setMindMap(mindMapA);
    setDossie(dossieA);
  }

  function dispatchSetContentAsDoneEvent(id: string) {
    const setContentAsDone = new CustomEvent('setContentAsDone', {
      detail: {
        contentId: id,
      },
    });
    window.dispatchEvent(setContentAsDone);
  }

  const onFinish = (id: string, slug: string) => {
    if (slug) {
      finishMaterial(slug);
      dispatchSetContentAsDoneEvent(id);
    }
  };

  const materialSections = [
    {
      title: 'Apostilas',
      items: workbook,
      category: 'Apostila',
      categoryPlural: 'Apostilas'
    },
    {
      title: 'Lista de exercícios',
      items: exercise,
      category: 'Exercício',
      categoryPlural: 'Exercícios'
    },
    {
      title: 'Mapa mental',
      items: mindMap,
      category: 'Mapa mental',
      categoryPlural: 'Mapas mentais'
    },
    {
      title: 'Dossiê',
      items: dossie,
      category: 'Dossiê',
      categoryPlural: 'Dossiês'
    }
  ]

  if (isPending) {
    return (
      <Fragment>
        {Array.from({ length: 10 }, (_, index) => (
          <CardLoader key={index} />
        ))}
      </Fragment>
    );
  }

  return (
    <div className='flex flex-col gap-lg'>
      <FilterModal
        title="Filtrar materiais"
        onSubmit={() => filterMaterials()}
        reset={() => resetFilters()}
        modalName='normal-filter'
        type="materiais"
      />
      {materialSections.map((section) => (
        section.items.length > 0 && (
          <Fragment key={section.category}>
            <SectionHeader title={section.title}>
              <Typography size='small'>
                {section.items.length || 0}{' '}
                {section.items.length <= 1 ? section.category : section.categoryPlural}
              </Typography>
            </SectionHeader>
            {section.items.map((it, i) => (
              <ContentCard
                color={discipline}
                key={i}
                title={it.title}
                done={it.done}
                favorite={it.favorite}
                icon='article'
                content='materiais'
                action={() => navigate(url + `/assunto/${it.subjects[0].slug}/material/${it.slug}`)}
                subject={getSubjectByFilter(it.subjects, selectedSubjects)}
                hasCallback
                callback={(data) => callbackFav(data)}
                slug={it.slug}
                onDone={(id: string, slug: string) => onFinish(id, slug)}
                id={it.id}
              >
                <Typography
                  size='small'
                  className=' transition delay-100 ease-in-out group-hover:text-card-color-default'
                >
                  {section.category}
                </Typography>
              </ContentCard>
            ))}
          </Fragment>
        )
      ))}
    </div>
  );
}